module.exports = __webpack_public_path__ + "stylesheets/wave-user-page_83ad6a4b121102f63ca01b8ed9ad5382.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-user-page.less
// module id = GIoJ
// module chunks = 51